/**
 * Get filter values present in query params.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @returns string|false
 */
export function getQueryParams() {
    const currentSearchParams = new URLSearchParams(window.location.search).toString();

    if (currentSearchParams !== '') {
        return currentSearchParams;
    }

    return false;
}
